import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';

import { Content } from "../../models/content";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']

})
export class LoginComponent implements OnInit {

  @Input()
  content: Content;
  
  private primaryColor: string;
  private isGuest: boolean;

  @Output() userChangeEvent = new EventEmitter<Content>();
  @Output() guestLoginEvent = new EventEmitter<boolean>();

  constructor() {

  }

  ngOnInit() {
    this.primaryColor = this.content.portal.primaryColor;
  }

  ngAfterViewInit(){

  }

  onUsernameChange(e: any): void{
    this.content.username = e;
    this.userChangeEvent.emit(this.content);
    this.isGuest = false;
  }

  onPasswordChange(e: any): void{
    this.content.password = e;
    this.userChangeEvent.emit(this.content);
    this.isGuest = false;
  }

  guestLogin(): void{
    this.guestLoginEvent.emit(true);
    this.isGuest = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts